import { getReq } from '../service/API'
import useSWR from 'swr'
import { ENDPOINTS } from '../service/ENDPOINTS'
import { useState } from 'react'

export const useSubjectAudit = (projectId: string, subjectId: string) => {
  const [pageNumber, setPageNumber] = useState<number>(1) // Default page
  const limit = 25

  const p = subjectId ? ENDPOINTS.SUBJECTS.getSubjectAuditPagination(projectId, subjectId, pageNumber, limit) : null
  const { data, error, isValidating, mutate } = useSWR(p, getReq, { suspense: true })

  return {
    data: !data ? data : data.data,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
    isValidating: isValidating,
    pageNumber,
    setPageNumber,
    limit,
  }
}
